import { HttpContextToken } from '@angular/common/http';

export const BYPASS_OFFLINE_GATE = new HttpContextToken<boolean>(() => false);
